import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const rows = [0, 1, 2, 3, 4, 5, 6, 7, 8];

export default function OverviewTable() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[900px] mx-auto px-8 md:px-12">
        <div className="text-center mb-12">
          {String(t('aboutAcademy.overview.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('aboutAcademy.overview.title')}
          </h2>
          {String(t('aboutAcademy.overview.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-6"></div>
          {String(t('aboutAcademy.overview.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-[2] max-w-[700px] mx-auto text-left md:text-center">{__s}</p>))}
        </div>

        <div className="border border-background-200/60 bg-background-100/40">
          {rows.map((row) => (
            <div
              key={row}
              className="grid grid-cols-1 sm:grid-cols-[180px_1fr] border-b border-background-200/60 last:border-b-0"
            >
              <div className="px-5 py-4 bg-background-100/70 text-[15px] text-foreground-700 tracking-[0.06em]">
                {t(`aboutAcademy.overview.${row}.label`)}
              </div>
              <div className="px-5 py-4 text-[16px] text-foreground-600 tracking-[0.03em] leading-[1.9]">
                {t(`aboutAcademy.overview.${row}.value`)}
              </div>
            </div>
          ))}
        </div>

        {String(t('aboutAcademy.overview.note')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed mt-5">{__s}</p>))}

        <div className="text-center mt-8">
          <Link
            to="/access"
            className="inline-flex items-center gap-2 text-[15px] text-accent-600 hover:text-accent-500 tracking-[0.05em] transition-colors"
          >
            <span>{t('aboutAcademy.overview.accessLink')}</span>
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
